import React from 'react'
import { useParams } from 'react-router-dom'
import { useWithdrawContext } from '../../../state-management/contexts/WithdrawContext'
import { OTPVerficationPage } from '../../OTP/OTPVerficationPage'
import { useUserDetails } from '../../../hooks/useUserDetails'

export const WithdrawOTPPage: React.FC = () => {
  const { isin: isinParam } = useParams<{ isin: string }>()
  const pathIsin = isinParam ?? ''
  const { otpVerificationState, otpVerificationHandlers } = useWithdrawContext()
  const { userDetails } = useUserDetails()

  return (
    <OTPVerficationPage
      numberOfDigits={6}
      phoneNumber={userDetails?.mobileNumber || ''}
      emailId={userDetails?.emailId || ''}
      isOTPVerified={otpVerificationState.isOTPVerified}
      OTPVerificationFailedCase={otpVerificationState.OTPVerificationFailedCase}
      isOTPVerificationLoading={otpVerificationState.isOTPVerificationLoading}
      isOTPVerificationLimitExceeded={otpVerificationState.isOTPVerificationLimitExceeded}
      handleResendOTP={otpVerificationHandlers.handleResendOTP}
      handleOTPVerification={otpVerificationHandlers.handleOTPVerification}
      inputContainerTestLocator='MFE_ENTER_OTP'
      trackingFund={pathIsin ? { fundIsin: pathIsin } : undefined}
    />
  )
}
